/* src/app/components/on-off-toggle/on-off-toggle.component.scss */
.toggle-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-width: 128px;
  height: 36px;
  border: 1px solid #02857D;
  cursor: pointer;
}
.toggle-container.deactivated {
  cursor: default;
  border-color: #E8E8E6;
}
.toggle-container.deactivated .on-half {
  border: none;
}
.toggle-container.deactivated .off-half.selected {
  background-color: #E8E8E6;
}
.toggle-container.deactivated .off-half.selected span {
  color: #bebebe;
}
.on-half {
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #02857D;
}
.on-half span {
  visibility: hidden;
  margin: 0 0.25rem;
}
.on-half.selected {
  background-color: #02857D;
}
.on-half.selected span {
  visibility: visible;
  color: white;
}
.off-half {
  display: flex;
  justify-content: center;
  align-items: center;
}
.off-half span {
  visibility: hidden;
  margin: 0 0.25rem;
}
.off-half.selected {
  background-color: #EDEDED;
}
.off-half.selected span {
  visibility: visible;
  color: #242424;
}
span {
  -webkit-user-select: none;
  user-select: none;
}
/*# sourceMappingURL=on-off-toggle.component.css.map */
